import React from 'react';

import '../common/Footer.scss'
import { BackTop } from 'antd';
// import { UpSquareFilled } from '@ant-design/icons';
import { QuestionCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { FloatButton } from 'antd';
import cdac_logo_footer from '../../assets/images/svg_img/logo_cdac_footer.svg';
import ministry_logo from '../../assets/images/svg_img/ministry_logo.svg';

function AppFooter() {
  return (
    <div className="container-fluid">
      <div className="footer">
        {/* <div className="logo">
          <a href="http://google.com">CDAC</a>
        </div> */}
        {/* <ul className="socials">
          <li><a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a></li>
          <li><a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a></li>
          <li><a href="https://www.linkedin.com/"><i className="fab fa-linkedin-in"></i></a></li>
          <li><a href="https://www.pinterest.com/"><i className="fab fa-pinterest-p"></i></a></li>
          <li><a href="https://www.instagram.com/"><i className="fab fa-instagram"></i></a></li>
        </ul> */}
        <div className="copyright"><h3 style={{ fontWeight: '600', margin: '10px'}}>©2025 Copyright: C-DAC Mumbai. All Rights Reserved</h3></div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          {/* <img src={cdac_logo_footer} className='logo-image' />
          <img src={ministry_logo} className='logo-image' /> */}
        </div>
        {/* <BackTop>
          <div className="goTop"><UpSquareFilled style={{width: '35px !important',}} /></div>
        </BackTop> */}

        {/* Go to top button fixed 5% from the left side */}
        <FloatButton.Group shape="circle" style={{ right: '95%', }}>

          <FloatButton.BackTop className="goTop" visibilityHeight={1} />
        </FloatButton.Group>
      </div>
    </div>
  );
}

export default AppFooter;